import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import MenuItem from '@mui/material/MenuItem';
import { theme } from 'oems/theme';

import * as StyledActions from './DocumentActionsMenu.styles';

import BillzTypography from 'components/BillzTypographies/BillzTypography';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

import { resources } from 'oems/resources';
import { Divider } from '@mui/material';
import navigationPaths from 'engine/navigationPaths';
import { GeneralErrorMessageModal } from 'components/GeneralErrorMessageModal/GeneralErrorMessageModal';
import { getUserPurchasePlanLimitStates } from 'api/endpoints/getUserPurchasePlanLimitStates';

export function DocumentActionsMenu(props) {
  const rowId = props.rowId;
  const isPaid = props.isPaid;
  const handleClose = props.handleClose;
  const navigate = useNavigate();
  const [errorDialogOpen, setErrorDialogOpen] = React.useState(false);

  const handleErrorDialogClose = () => {
    setErrorDialogOpen(false);
  };

  const handleErrorDialogConfirm = () => {
    setErrorDialogOpen(false);
    navigate(navigationPaths().Pricing);
  };

  const onPreHandleClose = (e) => {
    let currentTargetId = { ...e };
    getUserPurchasePlanLimitStates().then((data) => {
      if (data.documentLimitExceeded) {
        setErrorDialogOpen(true);
      } else {
        handleClose(currentTargetId);
      }
    });
  };

  return (
    <React.Fragment>
      {errorDialogOpen && (
        <GeneralErrorMessageModal
          id="error-message"
          onClose={handleErrorDialogClose}
          onConfirm={handleErrorDialogConfirm}
          title="Limit wyczerpany"
          closeText="Przejdź do Planów cenowych"
          message="Przekroczony został dostępny limit tworzonych dokumentów."
        />
      )}
      <StyledActions.MenuList>
        {props.preview && (
          <MenuItem id="preview" onClick={handleClose} disableRipple>
            <StyledActions.IconL>
              <resources.PreviewIcon />
            </StyledActions.IconL>
            <BillzTypography>Podgląd</BillzTypography>
          </MenuItem>
        )}
        {props.edit && (
          <MenuItem id="edit" onClick={handleClose} disableRipple>
            <StyledActions.IconL>
              <resources.EditIcon />
            </StyledActions.IconL>
            <BillzTypography>Edytuj</BillzTypography>
          </MenuItem>
        )}
        {props.pdf && (
          <MenuItem id="pdf" onClick={handleClose} disableRipple>
            <StyledActions.IconL>
              <resources.PdfIcon />
            </StyledActions.IconL>
            <BillzTypography>Pobierz PDF</BillzTypography>
          </MenuItem>
        )}
        {props.duplicatePdf && (
          <MenuItem id="duplicatePdf" onClick={handleClose} disableRipple>
            <StyledActions.IconL>
              <PictureAsPdfIcon />
            </StyledActions.IconL>
            <BillzTypography>Pobierz duplikat PDF</BillzTypography>
          </MenuItem>
        )}        
        <Divider sx={{ my: 0.5 }} />
        {props.reinvoice && (
          <MenuItem id="reinvoice" onClick={onPreHandleClose} disableRipple>
            <StyledActions.IconL>
              <resources.ReinvoiceIcon />
            </StyledActions.IconL>
            <BillzTypography>Wystaw ponownie</BillzTypography>
          </MenuItem>
        )}
        {props.payment && (
          <MenuItem id="payment" onClick={handleClose} disableRipple>
            <StyledActions.IconL>
              <resources.MarkNotPaidIcon />
            </StyledActions.IconL>
            <BillzTypography>{isPaid ? 'Oznacz jako nieopłacona' : 'Oznacz jako opłacona'}</BillzTypography>
          </MenuItem>
        )}
        {props.invoice && (
          <MenuItem id="invoice" onClick={onPreHandleClose} disableRipple>
            <StyledActions.IconL>
              <resources.ReinvoiceIcon />
            </StyledActions.IconL>
            <BillzTypography>Wystaw fakturę</BillzTypography>
          </MenuItem>
        )}
        {props.correction && (
          <MenuItem id="correction" onClick={onPreHandleClose} disableRipple>
            <StyledActions.IconL>
              <resources.AddCorrectionIcon />
            </StyledActions.IconL>
            <BillzTypography>Dodaj korektę</BillzTypography>
          </MenuItem>
        )}
        {props.remove && (
          <MenuItem id="delete" onClick={handleClose} disableRipple>
            <StyledActions.IconL>
              <resources.RemoveIcon />
            </StyledActions.IconL>
            <BillzTypography color={theme.palette.error.main}>Usuń</BillzTypography>
          </MenuItem>
        )}
        {props.removeSelected && (
          <MenuItem id="deleteSelected" onClick={handleClose} disableRipple>
            <StyledActions.DeleteSelected />
            <StyledActions.DangerLabel>Usuń zaznaczone</StyledActions.DangerLabel>
          </MenuItem>
        )}
      </StyledActions.MenuList>
    </React.Fragment>
  );
}
